<fadv-modal #userModal size="large" [preventClosing]="true" size='medium'>
    <fadv-toast #toastChangeStatus>
        Updating User Status to {{ userStatus }}
    </fadv-toast>
    <fadv-box>
        <a href="https://fadv.com/smallbusiness/support/" target="_new">
            <fadv-toast #toastSubmitError [duration]="50000">
            </fadv-toast>
        </a>
    </fadv-box>
    <fadv-toast #toastNonExistError [duration]="50000">
    </fadv-toast>
    <fadv-toast-outlet position='top-center'>
    </fadv-toast-outlet>
    <fadv-modal-header>
        {{ modalHeader }}
    </fadv-modal-header>
    <fadv-modal-body>
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <fadv-box>
                <fadv-grid>
                    <fadv-grid-row>
                        <fadv-grid-col alignment='right' [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 6, xs: 6 }">
                            <fadv-typography pr="x-small" variant="{{ firstNameVariant }}" type="label-medium"
                                weight="500" id="cardTop">
                                {{ displayFirstName }}</fadv-typography>
                        </fadv-grid-col>
                        <fadv-grid-col alignment='left' [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 6, xs: 6 }">
                            <fadv-typography variant="{{ lastNameVariant }}" type="label-medium" weight="500"
                                id="cardTop"> {{ displayLastName }}</fadv-typography>
                        </fadv-grid-col>
                    </fadv-grid-row>
                    <fadv-grid-row>
                        <fadv-grid-col alignment='left' [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 6, xs: 6 }">
                            <fadv-box pl="small" pt="large">
                                <fadv-typography>Status</fadv-typography>
                            </fadv-box>
                        </fadv-grid-col>
                        <fadv-grid-col variant="success" alignment='right'
                            [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 6, xs: 6 }">
                            <fadv-box pr="small" pt="large">
                                <fadv-switch #statusSwitch formControlName="status" (click)="this.changeStatus()">
                                </fadv-switch>
                            </fadv-box>
                        </fadv-grid-col>
                    </fadv-grid-row>
                    <fadv-grid-row>
                        <fadv-grid-col alignment='center' [col]="{ xxl: 12, xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }">
                            <fadv-box>
                                <fadv-input [invalid]="this.firstNameInvalid"
                                    (blur)="this.showValidation('firstName'); this.updateFirstName();"
                                    autofocus="autofocus" formControlName="firstName" label="Legal First Name *"
                                    type="text">
                                    <fadv-icon foreground="primary" fadvPrefixIcon library='solid' name='fa-user'>
                                    </fadv-icon>
                                </fadv-input>
                                <span *ngIf="this.firstNameInvalid == true">
                                    <small *ngIf="form.get('firstName').hasError('required')" class="text-danger">First
                                        Name is Required</small>
                                    <small *ngIf="form.get('firstName').hasError('pattern')" class="text-danger">First
                                        Name cannot contain
                                        numbers</small>
                                    <small
                                        *ngIf="form.get('firstName').hasError('whitespace') && !form.get('firstName').hasError('required')"
                                        class="text-danger">First Name cannot be empty</small>
                                </span>
                            </fadv-box>
                        </fadv-grid-col>
                    </fadv-grid-row>
                    <fadv-grid-row>
                        <fadv-grid-col alignment='center' [col]="{ xxl: 12, xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }">
                            <fadv-input [invalid]="this.lastNameInvalid"
                                (blur)="this.showValidation('lastName'); this.updateLastName();"
                                formControlName="lastName" label="Legal Last Name *" type="text">
                                <fadv-icon foreground="primary" fadvPrefixIcon library='solid' name='fa-user'>
                                </fadv-icon>
                            </fadv-input>
                            <span *ngIf="this.lastNameInvalid == true">
                                <small *ngIf="form.get('lastName').hasError('required')" class="text-danger">Last
                                    Name is Required</small>
                                <small *ngIf="form.get('lastName').hasError('pattern')" class="text-danger">Last
                                    Name cannot contain numbers</small>
                                <small
                                    *ngIf="form.get('lastName').hasError('whitespace') && !form.get('lastName').hasError('required')"
                                    class="text-danger">Last Name cannot be empty</small>
                            </span>
                        </fadv-grid-col>
                    </fadv-grid-row>
                    <fadv-grid-row>
                        <fadv-grid-col alignment='center' [col]="{ xxl: 12, xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }">
                            <fadv-input [invalid]="this.emailInvalid" (blur)="this.showValidation('email')"
                                formControlName="email" type="email" label="Email *">
                                <fadv-icon foreground="primary" fadvPrefixIcon library='solid' name='fa-envelope'>
                                </fadv-icon>
                            </fadv-input>
                            <span *ngIf="this.emailInvalid == true">
                                <small *ngIf="form.get('email').hasError('email')" class="text-danger">Email is
                                    Required</small>
                            </span>
                        </fadv-grid-col>
                    </fadv-grid-row>
                    <fadv-grid-row>
                        <fadv-grid-col alignment='center' [col]="{ xxl: 12, xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }">
                            <fadv-input [invalid]="this.confirmEmailInvalid"
                                (blur)="this.showValidation('confirmEmail')" formControlName="confirmEmail" type="email"
                                label="Confirm Email *">
                                <fadv-icon foreground="primary" fadvPrefixIcon library='solid' name='fa-envelope'>
                                </fadv-icon>
                            </fadv-input>
                            <small *ngIf="this.confirmEmailInvalid == true" class="text-danger">Email
                                must match</small>
                        </fadv-grid-col>
                    </fadv-grid-row>
                    <fadv-grid-row>
                        <fadv-grid-col alignment='center' [col]="{ xxl: 12, xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }">
                            <fadv-input
                                (blur)="form.get('phoneNumber').markAsDirty(); this.showValidation('phoneNumber');"
                                [maxlength]="10" type="tel" [minlength]="10" requiredautocapitalize="false"
                                autocomplete="false" autocorrect="false" clearable="" inputmode="text" id="phoneNumber"
                                label="Phone Number*" max="250" maxLength="250" min="1" minLength="0" name="phoneNumber"
                                value="" variant="primary" formControlName="phoneNumber"
                                [invalid]="form.get('phoneNumber')?.invalid && form.get('phoneNumber')?.dirty">
                                <fadv-icon foreground="primary" fadvPrefixIcon library='solid' name='fa-phone'>
                                </fadv-icon>
                            </fadv-input>
                            <fadv-box pl="x-small">
                                <span class="error" *ngIf="this.phoneNumberInvalid == true">
                                    <small *ngIf="form.get('phoneNumber').hasError('required')">Phone
                                        Number is Required</small>
                                    <small
                                        *ngIf="form.get('phoneNumber').hasError('minlength') || form.get('phoneNumber').hasError('pattern')">Phone
                                        Number must be 10 numbers</small>
                                </span>
                            </fadv-box>
                        </fadv-grid-col>
                    </fadv-grid-row>
                    <fadv-grid-row>
                        <fadv-grid-col pt="x-large" alignment="{{ cancelAlignment }}"
                            [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }">
                            <fadv-box pt="x-large">
                                <fadv-button width="100%" (click)="hide()"
                                name="user-modal-cancel-button">Cancel</fadv-button>
                            </fadv-box>
                        </fadv-grid-col>
                        <fadv-grid-col pt="{ md: 'x-large', sm: 'x-small' }" alignment="{{ confirmAlignment }}"
                            [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }">
                            <fadv-box pt="x-large">
                                <fadv-button variant="primary" (click)="onSubmit()"
                                name="user-modal-confirm-button">Confirm</fadv-button>
                            </fadv-box>
                        </fadv-grid-col>
                    </fadv-grid-row>
                </fadv-grid>
            </fadv-box>
        </form>
    </fadv-modal-body>
</fadv-modal>

<!-- <fadv-grid-row>
    <fadv-grid-col [offset]="{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 4, xs: 4 }"
        [col]="{ xxl: 4, xl: 4, lg: 4, md: 4, sm: 12, xs: 12 }">
        <fadv-box pt="x-large">
            <fadv-button width="100%">Cancel</fadv-button>
        </fadv-box>
    </fadv-grid-col>
    <fadv-grid-col [offset]="{ xxl: 0, xl: 0, lg: 0, md: 0, sm: 4, xs: 4 }"
        [col]="{ xxl: 3, xl: 3, lg: 3, md: 3, sm: 12, xs: 12 }">
        <fadv-box pt="x-large">
            <fadv-button variant="primary">Confirm</fadv-button>
        </fadv-box>
    </fadv-grid-col>
</fadv-grid-row> -->

<!-- <fadv-grid-row>
    <fadv-grid-col alignment="{{ cancelAlignment }}"
        [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }">

            <fadv-button width="100%">Cancel</fadv-button>

    </fadv-grid-col>
    <fadv-grid-col alignment="{{ confirmAlignment }}"
        [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }">

            <fadv-button variant="primary">Confirm</fadv-button>

    </fadv-grid-col>
</fadv-grid-row> -->